/** Curated AI models for Settings → AI and AI Search. */

/** Older ids Anthropic no longer accepts → current replacements. */
export const RETIRED_MODEL_MAP = {
  'claude-3-5-haiku-20241022': 'claude-haiku-4-5',
  'claude-3-5-sonnet-20241022': 'claude-sonnet-4-5',
  'claude-3-haiku-20240307': 'claude-haiku-4-5',
  'claude-3-sonnet-20240229': 'claude-sonnet-4-5',
  'claude-3-opus-20240229': 'claude-opus-4-20250514',
}

export function resolveModelId(model) {
  if (!model) return model
  return RETIRED_MODEL_MAP[model] || model
}

export const AI_PROVIDERS = [
  {
    value: 'openai',
    label: 'OpenAI',
    defaultModel: 'gpt-4o-mini',
    hint: 'API keys from platform.openai.com',
    models: [
      { value: 'gpt-4o-mini', label: 'GPT-4o mini (fast, lower cost)' },
      { value: 'gpt-4o', label: 'GPT-4o' },
      { value: 'gpt-4.1-mini', label: 'GPT-4.1 mini' },
      { value: 'gpt-4.1', label: 'GPT-4.1' },
      { value: 'o4-mini', label: 'o4-mini (reasoning)' },
    ],
  },
  {
    value: 'anthropic',
    label: 'Anthropic (Claude)',
    defaultModel: 'claude-haiku-4-5',
    hint: 'API keys from console.anthropic.com',
    models: [
      { value: 'claude-haiku-4-5', label: 'Claude Haiku 4.5 (fast)' },
      { value: 'claude-sonnet-4-5', label: 'Claude Sonnet 4.5' },
      { value: 'claude-sonnet-4-20250514', label: 'Claude Sonnet 4' },
      { value: 'claude-opus-4-20250514', label: 'Claude Opus 4' },
      { value: 'claude-sonnet-5', label: 'Claude Sonnet 5' },
      { value: 'claude-opus-5', label: 'Claude Opus 5' },
    ],
  },
]

export const CUSTOM_MODEL = '__custom__'

export function providerMeta(provider) {
  return AI_PROVIDERS.find((p) => p.value === provider) || AI_PROVIDERS[0]
}

export function modelSelectValue(provider, model) {
  const resolved = resolveModelId(model)
  const meta = providerMeta(provider)
  const known = meta.models.some((m) => m.value === resolved)
  return known ? resolved : CUSTOM_MODEL
}
